/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import ReactDOM from 'react-dom';

import './styles';

// Your top level component
import App from './components/App';
import './htmlJobs';
import './i18n';

if (typeof window !== 'undefined') {
  window.Appcues = window.Appcues || { anonymous() {} };
}

// Export your top level component as JSX (for static rendering)
export default App;

// Render your app
if (typeof document !== 'undefined') {
  const render = Comp => {
    ReactDOM.render(<Comp />, document.getElementById('root'));
  };

  // Render!
  render(App);
}



// WEBPACK FOOTER //
// ../src/index.js